import script from "./AppLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AppLayout.vue?vue&type=style&index=0&id=9772bd62&lang=css"
import "./AppLayout.vue?vue&type=style&index=1&id=9772bd62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9772bd62"]])

export default __exports__